import { useEffect, useState } from "react"
import { Navigate, Outlet, useNavigate } from "react-router-dom"
import Header from "./Header"
import Cookies from 'js-cookie'

export default function PrivateRoute(props) {
    const { Component } = props;
    const [userToken, setuserToken] = useState(Cookies.get("userToken"))
    console.log("isToken", userToken)
    // let isToken = Cookies.get("tokennn")
    const navigate = useNavigate();
    useEffect(() => {
        if (!userToken) {
            navigate("/login")
        }
    })
    return (
        <>
            <Header />
            <Component />
        </>
    )

}